<template>
  <!-- 弹窗 -->
  <a-modal
    :cancel-text="a_modal.cancelText"
    :ok-text="a_modal.okText"
    :title="a_modal.title"
    v-model:open="a_modal.visible"
    @ok="a_modal.handleOk"
  >
    {{ a_modal.content }}
  </a-modal>

  <div>
    <div class="header" @click="backToHome">
      <LeftOutlined />
      返回
    </div>

    <div class="rank">
      <a-tabs>
        <a-tab-pane>
          <template #tab>
            <div>
              <ToolTwoTone style="font-size: 18px;" />
              <span style="font-size: 14px;">客户评价</span>
            </div>
          </template>
          
          <div>
            <span>客服服务：</span>
            <a-rate v-model:value="score[0]" :tooltips="desc" />
            <span class="ant-rate-text">{{ desc[score[0] - 1] }}</span>
          </div>
          <div>
            <span>技师服务：</span>
            <a-rate v-model:value="score[1]" :tooltips="desc" />
            <span class="ant-rate-text">{{ desc[score[1] - 1] }}</span>
          </div>
          <div>
            <span>整体效率：</span>
              <a-rate v-model:value="score[2]" :tooltips="desc" />
            <span class="ant-rate-text">{{ desc[score[2] - 1] }}</span>
          </div>
          <div style="margin-top: 20px;">
            <a-textarea v-model:value="comment" :rows="4" placeholder="请留下您的评价" />
          </div>
          <div class="btn">
            <a-button type="primary" @click="submit">提交</a-button>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
  
<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { LeftOutlined, ToolTwoTone } from '@ant-design/icons-vue'

const route = useRoute()
const router = useRouter()
const uuid = ref(null)
const a_modal = ref({
  cancelText: '取消',
  content: '',
  handleOk: null,
  okText: '确定',
  title: '',
  visible: false
})
const score = ref([4, 4, 4]);
const desc = ref(['极差', '较差', '一般', '很好', '满意']);
const comment = ref('');
const backToHome = () => {
  router.push(`/${uuid.value}`)
}
const postRank = () => {
  return axios.post('https://api.gdpinganxing.com/api/cs/rank', {
    uuid: uuid.value,
    staff_rank: score.value[0],
    service_rank: score.value[1],
    speed_rank: score.value[2],
    comment: comment.value
  })
}
const submit = async() => {
  const response = await postRank()
  if (response.data.code == 200) {
    a_modal.value.title = 'Tips:'
    a_modal.value.content = '评价成功！感谢您的配合！'
    a_modal.value.visible = true
    a_modal.value.handleOk = () => {
    a_modal.value.visible = false
      router.push(`/${uuid.value}`)
    }
  }
}
onMounted(() => {
  uuid.value = route.params.id
})
</script>

<style scoped>
.rank {
  margin-top: 58px;
  padding-top: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}
.btn {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.btn > input {
  margin-right: 16px;
}
</style>